module.exports = __webpack_public_path__ + "static/media/Aaron Chatterley, Founder - FeelUnique.29879f4e.png";